if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true,
    });
    setTimeout( () => {
        let status = "closed"
        document.querySelector( ".__akia-chat-icon" ).title = "Chat with Us"
        let __akia_chat_icon = document.querySelector( ".__akia-chat-icon" )
        __akia_chat_icon.style.backgroundImage = "url(https://symphony.cdn.tambourine.com/_hogan-hotels/media/royalkonaresort-royalkona-chaticon-01-66159fcb3c979.png)"
        if( __akia_chat_icon ){
            __akia_chat_icon.addEventListener( "click", function(){
                if( status == "closed" ){
                    __akia_chat_icon.style.backgroundImage = "url(https://sys.akia.ai/images/webchat/chat-close.png)"
                    status = "opened"
                }else{
                    __akia_chat_icon.style.backgroundImage = "url(https://symphony.cdn.tambourine.com/_hogan-hotels/media/royalkonaresort-royalkona-chaticon-01-66159fcb3c979.png)"
                    status = "closed"
                }
            })
            __akia_chat_icon.style.backgroundSize = "35px 35px"
        }
    }, 200 )

})();